<template>
<div>
  <FormRow class="designation" inline>
    <FormSelect field="custom.designation">
      <option>General Donation</option>
      <option>Chai Summer</option>
      <option>Chai Programming</option>
      <option>Regional Programming</option>
      <option>Chapter Programming</option>
      <option>Scholarship Fund</option>
      <option>Chavruta Program</option>
      <option value="JSU Expansion">JSU Expansion</option>
    </FormSelect>

    <FormSelect
      field="custom.subDesignation"
      v-if="getValue('custom.designation') == 'Chapter Programming'"
    >
      <option></option>
      <option value="Jerusalem Chapter">Jerusalem</option>
      <option value="Modiin Chapter">Modiin</option>
      <option value="Raanana Chapter">Raanana</option>
      <option value="Bet Shemesh Chapter">Bet Shemesh</option>
      <option value="Gush Etzion Chapter">Gush Etzion</option>
    </FormSelect>

    <FormSelect
      field="custom.regionalSubDesignation"
      v-if="getValue('custom.designation') == 'Regional Programming'"
    >
      <option></option>
      <option>Regional Shabbatons</option>
      <option>Mega Events</option>
      <option value="Jerusalem Marathon">TEAM NCSY</option>
    </FormSelect>

    <ErrorLabel field="custom.designation" />
    <ErrorLabel field="custom.subDesignation" />    
  </FormRow>
</div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, settings, setValue, form } = usePaymentForm();

    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Chapter Programming") {
          setValue("applications.0.campaign", null);
        } else {
          setValue("applications.0.campaign", val);
          setValue("applications.0.subCampaign", null);
        }
      }
    );

    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if (val) {
          setValue("applications.0.campaign", val);
          setValue("applications.0.subCampaign", null);
        }
        else {
          setValue("applications.0.campaign", "General Donation");
          setValue("applications.0.subCampaign", null);
        }
      }
    );

    watch(
      () => getValue("custom.regionalSubDesignation"),
      (val) => {
        if(val == 'Jerusalem Marathon') {
          setValue("applications.0.campaign", "Jerusalem Marathon");
          setValue("applications.0.subCampaign", null);
          return
        }
        if (!val) setValue("applications.0.campaign", "Regional Programing");
        else setValue("applications.0.subCampaign", val);
      }
    );

    return {
      getValue,
      form,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  ::v-deep select {
    flex: 1;
    min-width: 32%;
    max-width: 33%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
